export default "__VITE_ASSET__B6OE$4FA__"